module.exports = {
    // hide specific bullet points in tables
    // (any CSS hack for this resulted in browser compatability issues)
    init: () => {
        // get all list items with a not_bullet item inside
        const notBulletClass = ".not_bullet";
        const notBulletItems =  document.querySelectorAll(notBulletClass);
        if (!notBulletItems) {
            console.error(`Could not find any span elements elements with the selector: ${notBulletClass}`);
        };
        notBulletItems.forEach(notBulletItem => {
            let notBulletParent = notBulletItem.parentElement;
            notBulletParent.style.cssText = "list-style-type: none;";
        });
    }
};
